import { render } from "./ViewFournisseurPage.vue?vue&type=template&id=3ac6a732&ts=true"
import script from "./ViewFournisseurPage.vue?vue&type=script&lang=ts"
export * from "./ViewFournisseurPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__